
const treeViewState = {
    state: {
        _nodeSelected: {},
        selected: {},
    },
    getters: {
        selectedNode(state) {
            return state._nodeSelected
        },
        nodeSelected(state) {
            return state._nodeSelected;
        },
        getSelected(state) {
            console.warn("[DEV] Getter 'getSelected' will be deprecated use 'nodeSelected' instead")
            return state.selected;
        },
    },
    mutations: {
        setSelected(state, item) {
            state.selected = item;
        },
        setNodeSelected(state, node) {
            state._nodeSelected = node;
        }
    },
    actions: {
        selectNode({ commit }, node) {
            commit("setNodeSelected", node);
        },
        select({ commit }, item) {
            console.warn("[DEV] Action 'select' will be deprecated, please use 'selectNode' instead");
            if (item) {
                commit("setNodeSelected", item);
            }
        }
    },

};

export default treeViewState;